import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../../utils/index.esm.js';

const OptionsPickerFieldSchema = makeFieldSchemaFromZod(
  z.string(),
  z.object({
    key: z.string().nonempty("Set the Key").describe("Set the key"),
    property: z.string().nonempty("Set the property").describe("Set the property")
  })
);
const OptionsPickerSchema = OptionsPickerFieldSchema.schema;

export { OptionsPickerFieldSchema, OptionsPickerSchema };
//# sourceMappingURL=schema.esm.js.map
